import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "typeInput", "contentInput", "assetInput", "blueprintInput", "optionsInput", "requiredInput", "billingAddressInput",
        "inputContainer", "toggleButton"
    ]

    static values = {
        startingType: String
    }

    connect() {
        this.typeInputTarget.querySelectorAll('input[type="radio"]').forEach((radio) => {
            radio.addEventListener("change", (event) => {
                this.handleTypeChange(event.target.value)
            })
        })

        this.handleTypeChange(this.startingTypeValue)

        this.toggleButtonTarget.addEventListener("click", (event) => {
            this.toggleButtonTarget.classList.toggle("rotate-180")
            this.inputContainerTarget.classList.toggle("hidden")
        })
    }

    handleTypeChange(value) {
        this.contentInputTarget.classList.add("hidden")
        this.assetInputTarget.classList.add("hidden")
        this.blueprintInputTarget.classList.add("hidden")
        this.optionsInputTarget.classList.add("hidden")
        this.requiredInputTarget.classList.add("hidden")
        this.setBillingAddressInputActive(false)

        switch (value) {
            case "spacer":
                break;
            case "title_h1":
            case "title_h2":
            case "title_h3":
            case "title_h4":
            case "title_h5":
            case "title_h6":
            case "text_plain":
                this.contentInputTarget.classList.remove("hidden")
                break;
            case "asset":
                this.assetInputTarget.classList.remove("hidden")
                this.contentInputTarget.classList.remove("hidden")
                break;
            case "nested_blueprint":
                this.blueprintInputTarget.classList.remove("hidden")
                break;
            case "form_submit_button":
            case "form_text_field":
            case "form_email_field":
            case "form_password_field":
            case "form_checkbox_field":
            case "form_text_area_field":
            case "form_room_checkbox_fields":
            case "form_room_type_dropdown_field":
            case "form_date_field":
            case "form_arrival_time_field":
            case "form_billing_address_field":
                this.requiredInputTarget.classList.remove("hidden")
                this.contentInputTarget.classList.remove("hidden")
                if (value === "form_billing_address_field") this.setBillingAddressInputActive(true)
                break;
            case "form_radio_field":
            case "form_dropdown_field":
                this.requiredInputTarget.classList.remove("hidden")
                this.contentInputTarget.classList.remove("hidden")
                this.optionsInputTarget.classList.remove("hidden")
                break;
        }
    }

    setBillingAddressInputActive(active) {
        if (!this.hasBillingAddressInputTarget) return

        this.billingAddressInputTarget.classList.toggle("hidden", !active)
        this.billingAddressInputTarget.querySelectorAll("input, select, textarea, button").forEach((input) => {
            input.disabled = !active
        })
    }
}
